function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.43 17.93a2.43 2.43 0 10-3.89 1.94v4.63h2.92v-4.63a2.42 2.42 0 00.97-1.94zm-2.92 15.41l-7.38-5.26a8.8 8.8 0 01-3.61-6.44 4.46 4.46 0 010-.5v-9.35a.92.92 0 01.79-.93 21.43 21.43 0 0010.18-4.19.84.84 0 011 0 21.39 21.39 0 0010.17 4.19.92.92 0 01.79.93v9.85a8.78 8.78 0 01-3.62 6.44l-7.37 5.26a.84.84 0 01-.95 0z"
}));